import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { mcpApi } from './mcpApi';

const KEY = ['users', 'me', 'mcp-token'] as const;

export const useMcpTokenMetadata = () =>
  useQuery({
    queryKey: KEY,
    queryFn: mcpApi.getMetadata,
  });

export const useGenerateMcpToken = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: mcpApi.generate,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
};

export const useRevokeMcpToken = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: mcpApi.revoke,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
};
